import { useEffect } from "react";

export default function useUpdateBodyClass(touched) {
  useEffect(() => {
    if (touched && document)
      document.documentElement.className += "DateInput--touched";
  }, [touched]);
}
